module.exports = __webpack_public_path__ + "static/media/01A.95bc85a6.png";